module.exports = __webpack_public_path__ + "img/cover_23sei1.c13d773f.jpg";